export default "https://legacy.eskolare-development.com/images/glyphs-center.png";